/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// Google Maps Api Loader
define('global/GoogleMapsLoader',[
    'jquery',
    './Logger'
], function ($, Logger) {
    'use strict';

    var cfg = window.RocConfig;
    var googleMapsApiDef;
    var callbackName;
    var libraries = ['places'];

    function resolve() {
        googleMapsApiDef.resolve(window.google && window.google.maps ? window.google.maps : false);
    }

    function loadApi() {
        if (googleMapsApiDef) {
            return googleMapsApiDef.promise();
        }

        googleMapsApiDef = new $.Deferred();

        // if google.maps already exists then resolve the promise because Google Maps API was loaded before
        if (window.google && window.google.maps) {
            resolve();
        } else {
            callbackName = 'googleMapsLoaded_' + new Date().getTime();
            var params = {
                'libraries': libraries.join(','),
                'callback': callbackName
            };

            if (cfg.google && cfg.google.mapsApiKey) {
                params['key'] = cfg.google.mapsApiKey;
            } else {
                Logger.warn('GoogleMapsLoader: RocConfiguration has no API key,  you can generate a new API key on the Google Developers Console');
            }

            // declare the global callback
            window[callbackName] = function () {
                resolve();

                // delete callback because it's not needed
                setTimeout(function() {
                    try {
                        delete window[callbackName];
                    } catch (e) {
                    }
                });
            };

            $.ajax({
                dataType: 'script',
                data: params,
                url: '//maps.googleapis.com/maps/api/js'
            });

        }

        return googleMapsApiDef.promise();
    }

    var GoogleMapsLoader = {
        loadApi: loadApi
    };

    Logger.debug('GoogleMapsLoader.js Loaded:', GoogleMapsLoader);

    return GoogleMapsLoader;
});
